/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForCostCenter extends models.ServiceAccountNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForCostCenter");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForCostCenter.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForCostCenter>): ServiceAccountNativeDetailsBaseForCostCenter {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForCostCenter(), model);
        ServiceAccountNativeDetailsBaseForCostCenter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForCostCenter>): ServiceAccountNativeDetailsBaseForCostCenter {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForCostCenter.newInstance(<ServiceAccountNativeDetailsBaseForCostCenter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForCostCenter) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForCostCenter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForCostCenter): boolean {
        if (models.ServiceAccountNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForCostCenter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
